import React from 'react';

// Ícones transcritos do build enviado (biancode-formulario-deploy-2026-09-18.zip).
// Inline de propósito: o bundle original não usava lib de ícones.

const IconWrap = ({ children, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    {children}
  </svg>
);

export const PinIcon = () => (
  <IconWrap>
    <path d="M12 21s7-5.28 7-12A7 7 0 1 0 5 9c0 6.72 7 12 7 12Z" fill="currentColor" />
    <circle cx="12" cy="9" r="2.5" fill="#080808" />
  </IconWrap>
);

export const MailIcon = () => (
  <IconWrap>
    <rect x="2.5" y="5" width="19" height="14" rx="1.5" fill="currentColor" />
    <path d="m4 7 8 6 8-6" stroke="#080808" strokeWidth="1.6" />
  </IconWrap>
);

export const InstagramIcon = () => (
  <svg className="instagram-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
    <circle cx="17.4" cy="6.7" r="1.1" fill="currentColor" />
  </svg>
);

export const CopyIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="8" y="8" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="m5 12.5 4.3 4.3L19 7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <circle cx="8" cy="8" r="7.5" stroke="currentColor" />
    <path d="m7.2 4.1 3.9 3.9-3.9 3.9M11.2 8H3.8" stroke="currentColor" />
  </svg>
);

export const SocialLink = ({ label, href, children }) => (
  <a className="social-icon" href={href} target="_blank" rel="noreferrer" aria-label={label}>
    {children}
  </a>
);

export const BiancodeLogo = () => (
  <svg className="biancode-logo" viewBox="0 0 202 35" role="img" aria-label="Biancode">
    <path d="M63.0509 14.8928C61.6277 13.637 59.6364 13.0091 57.0889 13.0091H50.6723V7.3042H46.5342V27.696H57.0889C59.6364 27.696 61.6217 27.0681 63.0509 25.8123C64.4742 24.5565 65.1918 22.7446 65.1918 20.3645C65.1918 17.9845 64.4802 16.1426 63.0509 14.8868V14.8928ZM59.9294 23.4083C59.2716 24.0841 58.3267 24.419 57.0889 24.419H50.6723V16.2921H57.0889C58.3267 16.2921 59.2716 16.627 59.9294 17.3028C60.5872 17.9785 60.9161 19.0011 60.9161 20.3705C60.9161 21.7399 60.5872 22.7326 59.9294 23.4083Z" />
    <path d="M71.9195 7.36377H67.7275V10.587H71.9195V7.36377ZM71.895 13.0088H67.7568V27.6957H71.895V13.0088Z" />
    <path d="M89.2612 13.0089H76.0873V16.286H88.1789C89.321 16.286 89.8891 16.866 89.8891 18.0261V18.7079H78.9398C77.3969 18.7079 76.2189 19.0965 75.4056 19.8799C74.5863 20.6573 74.1797 21.7636 74.1797 23.1869C74.1797 24.6101 74.5863 25.7463 75.4056 26.5237C76.2248 27.3011 77.4029 27.6958 78.9398 27.6958H94.0273V17.5119C94.0273 16.0886 93.6685 14.9763 92.9449 14.187C92.2214 13.3976 90.9955 13.0029 89.2672 13.0029ZM89.8891 24.4188H79.6813C79.3225 24.4188 79.0414 24.3051 78.8381 24.0779C78.6408 23.8507 78.5391 23.5576 78.5391 23.1928C78.5391 22.8281 78.6408 22.541 78.8381 22.3258C79.0355 22.1045 79.3165 21.9968 79.6813 21.9968H89.8891V24.4188Z" />
    <path d="M109.964 13.0088H97.1611V27.6957H101.299V16.2858H108.942C110.084 16.2858 110.652 16.8539 110.652 17.9961V27.6957H114.79V17.5117C114.79 16.1602 114.407 15.0719 113.636 14.2466C112.865 13.4214 111.645 13.0088 109.97 13.0088Z" />
    <path d="M122.468 23.5339C121.811 22.8522 121.482 21.7937 121.482 20.3705C121.482 18.9473 121.811 17.8589 122.468 17.1772C123.126 16.4955 124.071 16.1486 125.309 16.1486H134.865V12.8716H125.309C122.761 12.8716 120.776 13.5055 119.347 14.7672C117.924 16.029 117.206 17.9008 117.206 20.3705C117.206 22.8402 117.918 24.6821 119.347 25.9439C120.77 27.2056 122.761 27.8395 125.309 27.8395H135.146V24.5625H125.309C124.071 24.5625 123.126 24.2216 122.468 23.5339Z" />
    <path d="M150.09 12.8657H144.816C142.268 12.8657 140.283 13.4996 138.854 14.7614C137.43 16.0232 136.713 17.8949 136.713 20.3646C136.713 22.8344 137.425 24.6762 138.854 25.938C140.277 27.1998 142.268 27.8337 144.816 27.8337H150.09C152.638 27.8337 154.623 27.1998 156.052 25.938C157.475 24.6762 158.193 22.8164 158.193 20.3646C158.193 17.9128 157.481 16.0232 156.052 14.7614C154.629 13.4996 152.638 12.8657 150.09 12.8657ZM152.931 23.534C152.273 24.2158 151.328 24.5626 150.09 24.5626H144.816C143.578 24.5626 142.633 24.2217 141.975 23.534C141.317 22.8523 140.989 21.7939 140.989 20.3706C140.989 18.9474 141.317 17.859 141.975 17.1773C142.633 16.4956 143.578 16.1487 144.816 16.1487H150.09C151.328 16.1487 152.273 16.4896 152.931 17.1773C153.588 17.859 153.917 18.9294 153.917 20.3706C153.917 21.8118 153.588 22.8523 152.931 23.534Z" />
    <path d="M174.703 13.009H168.286C165.739 13.009 163.754 13.6369 162.324 14.8927C160.901 16.1485 160.184 17.9724 160.184 20.3704C160.184 22.7684 160.895 24.5624 162.324 25.8182C163.748 27.074 165.739 27.7019 168.286 27.7019H178.841V7.31006H174.703V13.015ZM168.286 24.4188C167.049 24.4188 166.104 24.084 165.446 23.4082C164.788 22.7325 164.459 21.7219 164.459 20.3704C164.459 19.0189 164.788 17.9784 165.446 17.3026C166.104 16.6269 167.049 16.292 168.286 16.292H174.703V24.4188Z" />
    <path d="M185.856 21.9075H196.638C200.077 21.9075 201.799 20.4125 201.799 17.4285C201.799 15.9634 201.357 14.8391 200.471 14.0498C199.586 13.2604 198.307 12.8657 196.638 12.8657H189.51C186.963 12.8657 184.977 13.4996 183.548 14.7614C182.125 16.0232 181.407 17.8949 181.407 20.3646C181.407 22.8344 182.119 24.6762 183.548 25.938C184.971 27.1998 186.963 27.8337 189.51 27.8337H201.063V24.5566H189.51C187.477 24.5566 186.257 23.6716 185.862 21.9015ZM189.504 16.1487H196.435C197.254 16.1487 197.661 16.5494 197.661 17.3447C197.661 17.7454 197.553 18.0564 197.332 18.2836C197.111 18.5108 196.812 18.6245 196.435 18.6245H185.88C186.335 16.968 187.543 16.1428 189.504 16.1428Z" />
    <path d="M26.5186 14.1035H13.6855V20.9028H26.5186V14.1035ZM26.5187.510742H7V7.31001H26.5187V.510742ZM26.5187 27.6958H7V34.4951H26.5187V27.6958ZM7.00043 7.3042H.201172V27.696H7.00043V7.3042ZM33.3188 20.8965H26.5195V27.6957H33.3188V20.8965ZM33.3188 7.3042H26.5195V14.1035H33.3188V7.3042Z" />
  </svg>
);
